import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles, not, or } from '@/js/libs/use-auth';

import Account from 'src/scenes/Account/index.ts';
import Status from 'src/scenes/Status/index.ts';

const index = true;

export const accountRouteObject = inferRouteObject({
  path: 'account',
  children: [
    { index, Component: Status.NotFound },
    {
      element: <PrivateRoute roles={not(Roles.ANONYMOUS)} redirectPath='/login' />,
      children: [
        { path: 'edit-settings', Component: Account.Profile },
        // TODO: remove the redirect after 22.12.2025
        { path: 'editSettings', element: <Navigate to='../edit-settings' replace /> },
      ],
    },
    {
      element: <Account.AdminAccessHistoryRoute />,
      children: [{ path: 'admin-access-history', Component: Account.AdminAccessHistory }],
    },
    {
      element: <PrivateRoute roles={or(Roles.ADMIN, Roles.COMPANY_ADMIN, Roles.USER_ADMIN)} noAccessComponent={Status.NotFound} />,
      children: [
        {
          path: 'company',
          Component: Account.Company,
          children: [
            { index, Component: Account.CompanyTab },
            { path: 'user-groups', Component: Account.CompanyUserGroupsList },
            {
              element: <PrivateRoute roles={not(or(Roles.SSO, Roles.POSTADMANAGER))} noAccessComponent={Status.NotFound} />,
              children: [
                { path: 'users', Component: Account.Users },
                { path: 'users/:userId/edit', Component: Account.EditUser },
              ],
            },
          ],
        },
      ],
    },
  ],
});
